module.exports = __webpack_public_path__ + "img/idcard2.c92a5c89.png";